/**
 * 日期格式的正则表达式
 * 例如匹配：2019-02-15
 *          2019/03/11
 */
const DATE_REGEX = /([1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]))|([1-9]\d{3}\/(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1]))/;
/**
 * 日期时间格式的正则表达式
 * 例如匹配：2019-02-15 12:45:23
 *          2019/03/11 12:45:23
 *          2019-02-15T12:45:23
 *          2019-02-15T12:45:23.123
 */
const DATE_TIME_REGEX = /(([1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]))|([1-9]\d{3}\/(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])))(\s|T)(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d((\.\d{1,3})|Z)?/;

/**
 * 相等验证，可用于密码与重复密码校验
 * {
 *  	validator: equalTo,
 *		compareTarget: {
 *			form: 'form1',
 *			field: 'repassword'
 *		},
 *		message: '两次密码不一致!'
 * }
 * @param rule
 * @param value
 * @param callback
 * @returns
 */
const equalTo = (rule, value, callback) => {
    if (value) {
        let _this = rule['vue'];
        let compareTargetValue = _this[rule.compareTarget.form][rule.compareTarget.field];
        if (compareTargetValue) {
            if (value != compareTargetValue) {
                return callback(new Error(rule.message));
            }
        }
    }
    callback();
};

/**
 * {
 * 		validator: date,
 * 		message: '不合法的日期格式!'
 * }
 * 
 * 验证是否是date
 * @param rule
 * @param value
 * @param callback
 * @returns
 */
const date = (rule, value, callback) => {
    //console.log(value);
    if (value) {
        if (!(value instanceof Date) && !DATE_REGEX.test(value)) {
            return callback(new Error(rule.message));
        }
    }
    callback();
};

/**
 * {
 * 		validator: datetime,
 * 		message: '不合法的日期时间格式!'
 * }
 * 
 * 验证是否是datetime
 * @param rule
 * @param value
 * @param callback
 * @returns
 */
const datetime = (rule, value, callback) => {
    if (value) {
        if (!(value instanceof Date) && !DATE_TIME_REGEX.test(value)) {
            return callback(new Error(rule.message));
        }

    }
    callback();
};

/**
 * {
 * 		validator: json,
 * 		message: '不是整数!'
 * }
 * 
 * 验证是否是JSON数据
 * @param rule
 * @param value
 * @param callback
 * @returns
 */
const json = (rule, value, callback) => {
    if (value) {
        try {
            JSON.parse(value);
        } catch (err) {
            return callback(new Error(rule.message));
        }
    }
    callback();
};

/**
 * 时间日期比较验证
 * 
 * {
 *  	validator: dateCompare,
 *		compareType: 'lt',
 *		compareTarget: {
 *			form: 'form1',
 *			field: 'promoteSaleEndTime'
 *		},
 *		message: '促销开始时间必须小于促销结束时间!'
 * }
 * {
 *  	validator: dateCompare,
 *		compareType: 'gt',
 *		compareTarget: {
 *			form: 'form1',
 *			field: 'promoteSaleStartTime'
 *		},
 *		message: '促销结束时间必须大于促销开始时间!'
 * }
 * 
 * @param rule
 * @param value
 * @param callback
 * @returns
 */
const dateCompare = (rule, value, callback) => {
    if (value) {
        let _this = rule['vue'];
        let compareTargetValue = _this[rule.compareTarget.form][rule.compareTarget.field];
        if (compareTargetValue) {
            if ('gt' == rule.compareType) { //大于
                if (value > compareTargetValue) {
                    callback();
                } else {
                    return callback(new Error(rule.message));
                }
            } else if ('gte' == rule.compareType) { //大于等于
                if (value >= compareTargetValue) {
                    callback();
                } else {
                    return callback(new Error(rule.message));
                }
            } else if ('lt' == rule.compareType) { //小于
                if (value < compareTargetValue) {
                    callback();
                } else {
                    return callback(new Error(rule.message));
                }
            } else if ('lte' == rule.compareType) { //小于等于
                if (value <= compareTargetValue) {
                    callback();
                } else {
                    return callback(new Error(rule.message));
                }
            } else {
                callback();
            }
        } else {
            callback();
        }
    } else {
        callback();
    }
};

const CustomValidator = {
    equalTo,
    date,
    datetime,
    json,
    dateCompare
};

CustomValidator.install = (Vue, options) => {
    Vue.directive('custom-validator-apply', {
        bind(el, binding, vnode) {
            let rules = binding.value;
            let _this = vnode.context;

            for (let [, fRule] of Object.entries(rules)) {
                for (let rule of fRule) {
                    rule['vue'] = _this;
                }
            }
        }
    });
};

export default CustomValidator;